import * as React from "react"
import {Box} from "@mui/material";

import {AppAntSwitch} from "@components";
import {ButtonSeeker, IconSeeker} from "@ui-seeker/core";
import {ORDER_WIDGET_BY} from "../../@contants";


export default function PriceEvolutionWidgetActions({ isPercentage, isSplitBySku, showListPrice, handleShowListPrice, orderBy, handleOrder }) {
	const orderByPrice = orderBy === ORDER_WIDGET_BY.PRICE
	const orderByName = orderBy === ORDER_WIDGET_BY.NAME

	let icon
	if (orderByName)
		icon = "arrow-down-a-z"
	else
		icon = isPercentage ? 'arrow-down-9-1' : 'arrow-down-1-9'

	return <Box	display="flex" gap={3}>
		<ButtonSeeker
			variant="outlined"
			onClick={() => handleOrder(orderByName ? ORDER_WIDGET_BY.PRICE : ORDER_WIDGET_BY.NAME)}
			startIcon={<IconSeeker
				iconWeight="regular"
				icon={icon}
			/>}
		>
			{ !!orderByPrice && 'Price' }
			{ !!orderByName && (isSplitBySku ? 'Retailer' : 'SKU') }
		</ButtonSeeker>

		<AppAntSwitch
			trueText="List Price"
			falseText="Actual Price"
			checked={showListPrice}
			onChange={e => handleShowListPrice(e.target.checked)}
		/>
	</Box>
}